import React from "react";
import CustomTooltip from "../../../components/CustomTooltip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";

const OfficeActionButton = ({
  id,
  setEdit,
  setOfficeId,
  toggleShowAddEditOffice,
  toggleShowDelete
}) => {
  return (
    <>
      <span className="flex items-center gap-2 justify-center">
        <CustomTooltip message={"Edit"}>
          <span>
            <FontAwesomeIcon
              icon={faEdit}
              size="1x"
              onClick={() => {
                setEdit(true);
                toggleShowAddEditOffice();
                setOfficeId(id);
              }}
            />
          </span>
        </CustomTooltip>
        <span>/</span>
        <CustomTooltip message={"Delete"}>
          <span>
            <FontAwesomeIcon
              icon={faTrash}
              size="1x"
              onClick={() => {
                setOfficeId(id);
                toggleShowDelete();
              }}
            />
          </span>
        </CustomTooltip>
      </span>
    </>
  );
};

export default OfficeActionButton;
